export class updateProjectStage {
  id: number;
  state: number;
  startDate: string;
  endDate: string;
  dependenceId: number;
}
